/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/1/22, 3:54 PM
 *
 */

import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid';

import { Test } from '../../types';

const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ');
};

interface ITestDropdown {
  testList: Test[];
  selectedTest: Test;
  setSelectedTest: (testList: Test) => void;
}

export const ProfileTestDropdown = ({ testList, selectedTest, setSelectedTest }: ITestDropdown) => {
  return (
    <Listbox value={selectedTest} onChange={setSelectedTest}>
      {({ open }) => (
        <>
          <div className="relative z-20 w-80 print:hidden">
            <Listbox.Button className="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-4 pl-4 pr-12 text-left text-xl shadow-sm focus:border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-500">
              <span className="flex items-center">
                <span className="ml-3 block truncate font-medium capitalize text-gray-700">
                  {selectedTest && Object.keys(selectedTest).length !== 0
                    ? selectedTest.name
                    : 'Please choose a test'}
                </span>
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-2 text-lg  shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {testList.map((test) => (
                  <Listbox.Option
                    key={test.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-gray-600 text-white' : 'text-gray-900',
                        'relative cursor-pointer select-none py-4 pl-3 pr-9 font-medium'
                      )
                    }
                    value={test}
                  >
                    {({ selected, active }) => (
                      <>
                        <div className="flex items-center">
                          <span
                            className={classNames(
                              selected ? 'font-medium' : 'font-normal',
                              'ml-3 block truncate capitalize'
                            )}
                          >
                            {test.name}
                          </span>
                        </div>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-indigo-600',
                              'absolute inset-y-0 right-0 flex items-center pr-4'
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};
